"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitOfMeasure = void 0;
var UnitOfMeasure;
(function (UnitOfMeasure) {
    UnitOfMeasure[UnitOfMeasure["ppb"] = 0] = "ppb";
    UnitOfMeasure[UnitOfMeasure["mg/L"] = 1] = "mg/L";
    UnitOfMeasure[UnitOfMeasure["ug/L"] = 2] = "ug/L";
    UnitOfMeasure[UnitOfMeasure["NTU"] = 3] = "NTU";
    UnitOfMeasure[UnitOfMeasure["S.U. @ 25\u00BAC"] = 4] = "S.U. @ 25\u00BAC";
    UnitOfMeasure[UnitOfMeasure["mg CaCO3/L"] = 5] = "mg CaCO3/L";
    UnitOfMeasure[UnitOfMeasure["per 100ml"] = 6] = "per 100ml";
    UnitOfMeasure[UnitOfMeasure["\u00BAC"] = 7] = "\u00BAC";
    UnitOfMeasure[UnitOfMeasure["units"] = 8] = "units";
    UnitOfMeasure[UnitOfMeasure["ng/L"] = 9] = "ng/L";
})(UnitOfMeasure = exports.UnitOfMeasure || (exports.UnitOfMeasure = {}));
//# sourceMappingURL=UnitOfMeasure.js.map